export type FeaturePrompt = {
  before?: string
  accent: string
  after?: string
}

export function FeaturePromptList({ prompts }: { prompts: FeaturePrompt[] }) {
  return (
    <div className="feature-prompt-list" aria-label="Example Ivy prompts">
      {prompts.map((prompt) => (
        <blockquote key={`${prompt.before ?? ''}${prompt.accent}${prompt.after ?? ''}`} className="feature-prompt-bubble">
          {prompt.before}
          <span>{prompt.accent}</span>
          {prompt.after}
        </blockquote>
      ))}
    </div>
  )
}
